export default "__VITE_ASSET__BCAOi7f8__"